"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var axios = require('axios');
var csrfElement;
var csrfTokenValue;

// We can only verify if document object is truthy by checking its type;
// since the window object does not exist on the server, it will throw a runtime error.
if (typeof document !== 'undefined') {
  csrfElement = document.querySelector('meta[name="csrf-token"]');
  if (csrfElement) {
    csrfTokenValue = csrfElement.getAttribute('content');
  }
}

// Wrapping the addCsrf function to preserve the reference to the CSRF token in Safari
function csrfContext(csrfToken) {
  return function addCsrf(config) {
    var customHeaders = config.headers;
    return csrfToken && config.useCsrf !== false ? _objectSpread(_objectSpread({}, config), {}, {
      headers: _objectSpread(_objectSpread({}, customHeaders), {}, {
        csrf: csrfToken
      })
    }) : config;
  };
}
var addCsrfMethod = csrfContext(csrfTokenValue);
axios.default.interceptors.request.use(addCsrfMethod);
axios.addCsrf = addCsrfMethod;
module.exports = axios;
